import Heading from '@tiptap/extension-heading';

export const CustomHeading = Heading.extend({
  addOptions() {
    return {
      ...this.parent?.(),
      getTiptapHeadingStylingString: (level) => 'color:#ff7700;', // default functie
    };
  },

  addAttributes() {
    return {
      ...this.parent?.(),
      style: {
        default: null, // niet hier instellen
        parseHTML: element => element.getAttribute('style'),
        renderHTML: (attributes, node) => {
          //console.log('renderHTML', attributes, node)
          // gebruik de level van de node en de optie uit configure()
          const style = this.options.getTiptapHeadingStylingString(attributes.level);
          return { style };
        },
      },
    };
  },
});